import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import api from "../../services/api";
import { If, Then } from "react-if";
import {
  View,
  Text,
  TouchableOpacity,
  ImageBackground,
  Linking,
} from "react-native";

import styles from "./style";

const CardForestAdoption = () => {
  const navigation = useNavigation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [country, setCountry] = useState("");
  const [filteredImages, setFilteredImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading1, setLoading1] = useState("");

  async function getCategories() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    const clientCountry = await AsyncStorage.getItem("client_country");
    setCountry(clientCountry);

    setLoading1(true);
    try {
      const {
        data: [items],
      } = await api.get("/categories", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const filteredCategories = items.filter((item) => {
        const isIRec = clientCountry === "italia" && item.name === "I-REC";
        const isSustentavel =
          clientCountry !== "brasil" && item.name.includes("Sustentável");

        return !isIRec && !isSustentavel;
      });

      setCategories(filteredCategories);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading1(false);
    }
  }

  async function selectedCategory(id, name) {
    await AsyncStorage.setItem("id_category", id.toString());
    navigation.navigate("MarketplaceCategories", { categoryName: name });
  }

  const images = [
    {
      source: require("../../../assets/banner-credCarb.png"),
      name: "banner-credCarb",
      categoryName: "USE Crédito de Carbono e Biodiversidade",
      /*  id_category, */
    },
    {
      source: require("../../../assets/banner-I-REC.webp"),
      name: "banner-I-REC",
      categoryName: "I-REC",
      /*   id_category, */
    },
    {
      source: require("../../../assets/banner-adocao.png"),
      name: "banner-adocao",
      categoryName: "Adote A Amazônia",
      /* id_category, */
    },

    {
      source: require("../../../assets/selos-carbono-neutro-banner.png"),
      name: "banner-selos",
      categoryName: "Selo Sustentável",
    },
  ];

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    const validImages = images.filter((image) => {
      if (
        (image.name === "banner-I-REC" || image.name === "banner-selos") &&
        country !== "brasil"
      ) {
        return false;
      }

      return true;
    });
    setFilteredImages(validImages);
  }, [country]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex(
        (prevIndex) => (prevIndex + 1) % filteredImages.length
      );
    }, 3500);

    return () => clearInterval(interval);
  }, [filteredImages]);

  const currentImage = filteredImages[currentImageIndex];

  const handlePress = async () => {
    if (currentImage?.categoryName === "Adote A Amazônia") {
      // ID 4 para banner-adocao
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      if (token) {
        const url = `https://api.homol.gpxecofi.com.br/it/trees?token=${token}`;
        // Use Linking para abrir o URL externo
        Linking.openURL(url).catch((err) =>
          console.error("Erro ao abrir o URL:", err)
        );
      } else {
        console.error("Token não encontrado.", err);
      }
    } /* else if (currentImage?.categoryName) {
      await AsyncStorage.setItem(
        "id_category",
        currentImage.id_category.toString()
      );
      navigation.navigate("MarketplaceCategories");
    } */ else {
      const selectedCategoryItem = categories.find(
        (category) => category.name === currentImage.categoryName
      );

      if (selectedCategoryItem) {
        await selectedCategory(
          selectedCategoryItem.id,
          selectedCategoryItem.name
        );
      } else {
        console.error(
          "Categoria não encontrada para a imagem:",
          currentImage.categoryName
        );
      }
    }
  };

  return (
    <TouchableOpacity onPress={handlePress} style={styles.container}>
      <If condition={!!currentImage}>
        <Then>
          <ImageBackground source={currentImage?.source} style={styles.overlay}>
            <View style={styles.overlay}>
              <If condition={currentImage?.name === "banner-adocao"}>
                <Then>
                  <Text style={styles.msgSalveAmazonia}>
                    <FormattedMessage id="cardForestAdoption.msgSalveAmazonia" />
                  </Text>
                </Then>
              </If>
              <If condition={currentImage?.name === "banner-credCarb"}>
                <Then>
                  <Text style={styles.msgSalveAmazonia}>
                    <FormattedMessage id="cardForestAdoption.msgCompreCredCarb" />
                  </Text>
                </Then>
              </If>
              <If condition={currentImage?.name === "banner-selos"}>
                <Then>
                  <Text style={styles.msgSalveAmazonia}>
                    <FormattedMessage id="cardForestAdoption.txtBannerSelos" />
                  </Text>
                </Then>
              </If>
              <View style={styles.buttonContainer}>
                <TouchableOpacity
                  onPress={handlePress}
                  style={styles.btnAdotar}
                >
                  <Text style={styles.btnAdotarText}>
                    <FormattedMessage id="cardForestAdoption.btnSaibaMais" />
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </ImageBackground>
        </Then>
      </If>
    </TouchableOpacity>
  );
};

export default CardForestAdoption;
